import { render, staticRenderFns } from "./BasicOverview.vue?vue&type=template&id=6d0d96c3"
import script from "./BasicOverview.vue?vue&type=script&lang=js"
export * from "./BasicOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports